import React from 'react';
import { css } from '@emotion/react';
import { Grid, LinearProgress, MenuItem, TextField } from '@material-ui/core';
import { CheckCircleOutline } from '@material-ui/icons';
import NavResponsiveModal, { ModalHeader } from '@/components/Navigation/NavResponsiveModal';
import { ModalContent, PrimaryButton, SecondaryButton } from '@/styles/blocks';
import FileDropZone from '@/components/OrderDetailsPage/FileDropZone';
import { Field, FieldLabel, FileSelected } from './blocks';

const dropZoneStyle = {
    height: '100px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: '5px',
    outline: '1px solid #c4c4c4',
    fontFamily: 'Montserrat',
    cursor: 'pointer',
};

// The upload flow both panels shared: drop a file, which uploads immediately and auto-fills the
// name, then name it and pick a type. Save stays disabled until all three are set.
const UploadModal = ({ draft, uploading, loading, valid, typeOptions, callbacks }) => (
    <NavResponsiveModal open={!!draft} onClose={callbacks.closeUpload} maxWidth="sm" fullWidth>
        <ModalHeader
            title="Upload Document"
            onClose={callbacks.closeUpload}
            css={css`
                border-bottom: 1px solid lightgray;
            `}
        />
        {uploading && (
            <LinearProgress
                color="primary"
                css={css`
                    width: 100%;
                `}
            />
        )}
        <ModalContent
            css={css`
                width: 100%;
            `}
        >
            <Field>
                {draft?.link ? (
                    <FileSelected>
                        File Selected
                        <CheckCircleOutline />
                    </FileSelected>
                ) : (
                    <FileDropZone
                        customLabel={' '}
                        customStyle={dropZoneStyle}
                        handleFileAdd={callbacks.handleFileAdd}
                        disabled={uploading}
                    />
                )}
            </Field>

            <Field>
                <FieldLabel>Name</FieldLabel>
                <TextField
                    variant="outlined"
                    fullWidth
                    value={draft?.name || ''}
                    onChange={(e) => callbacks.editDraft({ name: e.target.value })}
                />
            </Field>

            <Field>
                <FieldLabel>Document Type</FieldLabel>
                <TextField
                    fullWidth
                    select
                    variant="outlined"
                    value={draft?.type || ''}
                    onChange={(e) => callbacks.editDraft({ type: e.target.value })}
                >
                    {typeOptions.map((docType) => (
                        <MenuItem key={docType.value} value={docType.value}>
                            {docType.label}
                        </MenuItem>
                    ))}
                </TextField>
            </Field>

            <Grid
                container
                direction="row"
                justifyContent="space-between"
                css={css`
                    margin-top: 24px;
                    width: 100%;
                `}
            >
                <SecondaryButton onClick={callbacks.closeUpload}>Cancel</SecondaryButton>
                <PrimaryButton disabled={!valid || loading} onClick={callbacks.save}>
                    Save
                </PrimaryButton>
            </Grid>
        </ModalContent>
    </NavResponsiveModal>
);

export default UploadModal;
